import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import {
  transactionFields,
  transactionEGOInfoFields,
} from '../../constants/transaction';
import {
  translateFuelTypeClassificator,
  translateHydrogenTechnologyClassificator,
  translateCleaningTechnologyClassificator,
} from '../../utils/translateHelpers';

class TransactionEGODetails extends React.Component {
  static propTypes = {
    info: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
  };

  render() {
    const { t, info } = this.props;

    const goInfo = info[transactionFields.GO_INFORMATION];
    const isHydrogen = goInfo.gas === 'HYDROGEN';
    return (
      <React.Fragment>
        <Row className="global-margin-bottom-10">
          <Col span={8}>
            <b>{t('go.amount')}: </b>
            {goInfo[transactionEGOInfoFields.GO_AMOUNT]}
          </Col>
        </Row>
        <Row className="global-margin-bottom-10">
          <Col span={8}>
            <b>{t('go.period')}: </b>
            {goInfo[transactionEGOInfoFields.ISSUE_PERIOD]}
          </Col>
          <Col span={8}>
            <b>{t('go.eicx')}: </b>
            {goInfo[transactionEGOInfoFields.UNIT_EICX]}
          </Col>
        </Row>
        <Row className="global-margin-bottom-10">
          <Col span={8}>
            <b>
              {isHydrogen
                ? t('go.hydrogenTechnology')
                : t('go.biomethaneTechnology')}
              :{' '}
            </b>
            {isHydrogen
              ? translateHydrogenTechnologyClassificator(
                  goInfo[transactionEGOInfoFields.TECHNOLOGY]
                )
              : translateCleaningTechnologyClassificator(
                  goInfo[transactionEGOInfoFields.TECHNOLOGY]
                )}
          </Col>
          <Col span={8}>
            <b>
              {isHydrogen ? t('go.hydrogenFuel') : t('go.biomethaneFuel')}:{' '}
            </b>
            {isHydrogen
              ? t(
                  'go.hydrogenType.' +
                    goInfo[transactionEGOInfoFields.HYDROGEN_FUEL_TYPE]
                )
              : translateFuelTypeClassificator(
                  goInfo[transactionEGOInfoFields.FUEL_TYPE]
                )}
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default TransactionEGODetails;
